// extracted by mini-css-extract-plugin
module.exports = {"Collapse":"Collapse--3GxBY","Toolbar":"Toolbar--3qW4n","Stack":"Stack--12fDG"};